import type {
  EditorReactComponent,
  EditorContextProvider,
} from '@wix/ambassador-devcenter-v1-component-type-data/types';
import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';

import {
  InternalResolvedOOIWidgetStatics,
  ResolveManifestOverridesFn,
} from '@wix/editor-platform-ooi-metadata-resolver';

export enum ManifestComponentExtensionType {
  CUSTOM_ELEMENT = ComponentType.CUSTOM_ELEMENT_WIDGET,
  OOI = ComponentType.WIDGET,
  BUILDER = ComponentType.EDITOR_REACT_COMPONENT,
  CONTEXT_PROVIDER = ComponentType.EDITOR_CONTEXT_PROVIDER,
  SYSTEM = 'SYSTEM',
  UNKNOWN = 'UNKNOWN',
}

/**
 * TODO: fix metadata generic types
 */
export interface MetadataByExtensionType {
  [ManifestComponentExtensionType.OOI]: {
    statics: InternalResolvedOOIWidgetStatics;
    hasLegacySettingsPanel?: boolean;
    resolveManifestOverrides?: ResolveManifestOverridesFn;
  };
  [ManifestComponentExtensionType.BUILDER]: null;
  [ManifestComponentExtensionType.CONTEXT_PROVIDER]: null;
  [ManifestComponentExtensionType.UNKNOWN]: null;
  [ManifestComponentExtensionType.SYSTEM]: null;
  [ManifestComponentExtensionType.CUSTOM_ELEMENT]: null;
}

export interface ManifestTypeByExtensionType {
  [ManifestComponentExtensionType.OOI]: EditorReactComponent;
  [ManifestComponentExtensionType.BUILDER]: EditorReactComponent;
  [ManifestComponentExtensionType.CONTEXT_PROVIDER]: EditorContextProvider;
  [ManifestComponentExtensionType.UNKNOWN]: EditorReactComponent;
  [ManifestComponentExtensionType.SYSTEM]: EditorReactComponent;
  [ManifestComponentExtensionType.CUSTOM_ELEMENT]: EditorReactComponent;
}
type KeysWithValue<TObj, TValue> = {
  [K in keyof TObj]-?: TObj[K] extends TValue ? K : never;
}[keyof TObj];

export type EditorReactComponentExtensionType = KeysWithValue<
  ManifestTypeByExtensionType,
  EditorReactComponent
>;

export type EditorContextProviderExtensionType = KeysWithValue<
  ManifestTypeByExtensionType,
  EditorContextProvider
>;

export interface IManifestStoreEntity<
  TExtensionType extends ManifestComponentExtensionType = ManifestComponentExtensionType,
> {
  extensionType: TExtensionType;
  componentType: string;
  manifest: ManifestTypeByExtensionType[TExtensionType];
  metadata: MetadataByExtensionType[TExtensionType];
  isPending?: boolean;
}

export type ManifestComponentType = string;
